export default __webpack_public_path__ + "5503c8e2713e276d4a2cdff45e6991c9.ttf";